import * as React from "react"

import Layout from "../../components/layout"
import Seo from "../../components/seo"
import ContactUsSection from "../../components/contact-us-section"
// import { Breadcrumb } from "gatsby-plugin-breadcrumb"
import Breadcrumb from "../../components/breadcrumbs"

const NotFoundPage = ({location}) => (
  <Layout>
    <Seo title="Rich Media Suppression" />
    
    <div className='bg-primary'>
      <div className='container d-flex flex-column position-relative'>
        <div className='row justify-content-center'>
          <div className='col-lg-6 py-6'>
            <h1 className='text-white text-center'>Walmart Product Types without Rich Media</h1>
          </div>
        </div>
          
      </div>
    </div>

    <div className="container py-4">
            <div className='row justify-content-center bg-white card p-4'>
                <p>Please read the following statement from Walmart regarding the temporary suspension of Rich Media from product detail pages that fall within specific product categories:</p>
                <p>"At the end of March, the “My Health, My Data” Act was put in place to protect online consumers’ personal health care data in the states of Washington and Nevada. The compliance regulation states that customers must “opt-in” for collection and sharing of any health and wellness-related data including data such as shopping history or tracking of shopping behaviors. To remain compliant, an internal, geo-targeted infrastructure allowing customers to choose, or not choose, to share their data is needed for our “About the Brand – Below the Fold Marketing Module.</p>
                    
                <p> While Walmart’s tech teams build a compliant data-sharing infrastructure, our course of action is to suppress 3rd party media or content associated with sensitive healthcare product types, as they could conflict with the “My Health, My Data” regulations. This includes Below-the-Fold marketing. </p>
                    
                <p>By Aug. 1st, we plan to implement the necessary infrastructure and reactivate the Below-the-Fold Marketing.</p> 
                
                <p> We understand the importance of enhanced content on the product page to our customers, suppliers/sellers, and our CCP/CSP partners. We apologize for the inconvenience this plan of action may cause. We will provide updates on the work related to the “My Health, My Data” Act over the next few months."</p>
                
                <p><b>The affected product types includes the following:</b></p>
                <div class="row">
                <div class="col-4"><li>Acne Clearing Devices</li></div>
                    <div class="col-4"><li>Acne Creams</li></div>
                    <div class="col-4"><li>Acne Treatment Systems</li></div>
                    <div class="col-4"><li>Adaptive Living Shampoo Basins & Trays</li></div>
                    <div class="col-4"><li>Adult Care Services</li></div>
                    <div class="col-4"><li>Adult Oriented Figures</li></div>
                    <div class="col-4"><li>Alcohol Test Strips</li></div>
                    <div class="col-4"><li>Allergy Tests</li></div>
                    <div class="col-4"><li>Amino Acid Supplements</li></div>
                    <div class="col-4"><li>Anal Bleaches</li></div>
                    <div class="col-4"><li>Anal Douches</li></div>
                    <div class="col-4"><li>Anal Sex Toys</li></div>
                    <div class="col-4"><li>Antifungal Remedies</li></div>
                    <div class="col-4"><li>Asthma Inhalers</li></div>
                    <div class="col-4"><li>Baby Bottle & Breast Pump Part Sterilizers</li></div>
                    <div class="col-4"><li>Back Support Belts</li></div>
                    <div class="col-4"><li>Ball Stretchers</li></div>
                    <div class="col-4"><li>Basal Thermometers</li></div>
                    <div class="col-4"><li>Bathing Cast & Wound Covers</li></div>
                    <div class="col-4"><li>Bed Safety & Assisting Rails</li></div>
                    <div class="col-4"><li>Bedpans & Urinals</li></div>
                    <div class="col-4"><li>Bedside Commodes</li></div>
                    <div class="col-4"><li>Bedwetting Alarms</li></div>
                    <div class="col-4"><li>Ben Wa Balls</li></div>
                    <div class="col-4"><li>Blood Glucose Monitors</li></div>
                    <div class="col-4"><li>Blood Glucose Test Strips</li></div>
                    <div class="col-4"><li>Blood Lancets</li></div>
                    <div class="col-4"><li>Blood Pressure Monitors</li></div>
                    <div class="col-4"><li>Bondage Chastity Devices</li></div>
                    <div class="col-4"><li>Bondage Gags & Muzzles</li></div>
                    <div class="col-4"><li>Bondage Paddles, Whips & Ticklers</li></div>
                    <div class="col-4"><li>Bondage Restraints</li></div>
                    <div class="col-4"><li>Braces, Splints & Slings</li></div>
                    <div class="col-4"><li>Breast Enlargement Pumps</li></div>
                    <div class="col-4"><li>Breast Pump Accessory Sets</li></div>
                    <div class="col-4"><li>Breast Pump Breast Shields</li></div>
                    <div class="col-4"><li>Breast Pump Replacement Tubing</li></div>
                    <div class="col-4"><li>Breast Pump Valves & Membranes</li></div>
                    <div class="col-4"><li>Breast Pumps</li></div>
                    <div class="col-4"><li>Breast Shells</li></div>
                    <div class="col-4"><li>Breastfeeding Supplements</li></div>
                    <div class="col-4"><li>Breastmilk Storage Bags</li></div>
                    <div class="col-4"><li>Breathalyzer Alcohol Monitors</li></div>
                    <div class="col-4"><li>Bunion Pads</li></div>
                    <div class="col-4"><li>Burn Care</li></div>
                    <div class="col-4"><li>Button Hook Dressing Aids</li></div>
                    <div class="col-4"><li>Callus Remover Replacement Screens</li></div>
                    <div class="col-4"><li>Cane Accessories</li></div>
                    <div class="col-4"><li>Casting Tape</li></div>
                    <div class="col-4"><li>Catheters</li></div>
                    <div class="col-4"><li>Cholesterol Monitors</li></div>
                    <div class="col-4"><li>Cholesterol Test Kits</li></div>
                    <div class="col-4"><li>Cold Sore & Fever Blister Treatments</li></div>
                    <div class="col-4"><li>Colo-rectal Disease Tests</li></div>
                    <div class="col-4"><li>Commode Liners</li></div>
                    <div class="col-4"><li>Compression Gloves, Sleeves & Socks</li></div>
                    <div class="col-4"><li>Computer Glasses</li></div>
                    <div class="col-4"><li>Condoms</li></div>
                    <div class="col-4"><li>Contact Lens Cases</li></div>
                    <div class="col-4"><li>Contact Lens Cleaners</li></div>
                    <div class="col-4"><li>Contact Lens Cleaning Systems</li></div>
                    <div class="col-4"><li>Contact Lens Inserters & Removers</li></div>
                    <div class="col-4"><li>Contraceptive Sponges</li></div>
                    <div class="col-4"><li>Corn & Callus Remover Cushions</li></div>
                    <div class="col-4"><li>Corn & Callus Trimmers</li></div>
                    <div class="col-4"><li>COVID-19 Test Kits</li></div>
                    <div class="col-4"><li>CPAP Bed Pillows</li></div>
                    <div class="col-4"><li>CPAP Cleaning Machines</li></div>
                    <div class="col-4"><li>CPAP Filters</li></div>
                    <div class="col-4"><li>CPAP Headgear</li></div>
                    <div class="col-4"><li>CPAP Machines</li></div>
                    <div class="col-4"><li>CPAP Masks</li></div>
                    <div class="col-4"><li>CPAP Tubing</li></div>
                    <div class="col-4"><li>Crutch Handgrips</li></div>
                    <div class="col-4"><li>Crutch Pads</li></div>
                    <div class="col-4"><li>Crutches</li></div>
                    <div class="col-4"><li>Defibrillators</li></div>
                    <div class="col-4"><li>Dental Crowns</li></div>
                    <div class="col-4"><li>Dental Protectors & Nightguards</li></div>
                    <div class="col-4"><li>Dental Veneers</li></div>
                    <div class="col-4"><li>Denture Adhesives</li></div>
                    <div class="col-4"><li>Denture Cases</li></div>
                    <div class="col-4"><li>Denture Cleansers</li></div>
                    <div class="col-4"><li>Denture Repair Kits</li></div>
                    <div class="col-4"><li>Diabetic Foot Care</li></div>
                    <div class="col-4"><li>Dildos</li></div>
                    <div class="col-4"><li>DNA Testing Kits</li></div>
                    <div class="col-4"><li>Dressing Aid Sticks</li></div>
                    <div class="col-4"><li>Drug Deactivation Pouches</li></div>
                    <div class="col-4"><li>Drug Tests</li></div>
                    <div class="col-4"><li>Ear Drops</li></div>
                    <div class="col-4"><li>Ear Vaccaria Seeds</li></div>
                    <div class="col-4"><li>Earpicks</li></div>
                    <div class="col-4"><li>Earwax Removal Candles</li></div>
                    <div class="col-4"><li>Earwax Removal Kits</li></div>
                    <div class="col-4"><li>Edible Sensual Products</li></div>
                    <div class="col-4"><li>Electric Wheelchairs</li></div>
                    <div class="col-4"><li>Electrodes</li></div>
                    <div class="col-4"><li>Electrolyte Supplements</li></div>
                    <div class="col-4"><li>Enema Supplies</li></div>
                    <div class="col-4"><li>Enteral Feeding Tubes & Supplies</li></div>
                    <div class="col-4"><li>Erotic Kits & Gift Sets</li></div>
                    <div class="col-4"><li>Eye Drops</li></div>
                    <div class="col-4"><li>Eye Ointments</li></div>
                    <div class="col-4"><li>Eye Patches</li></div>
                    <div class="col-4"><li>Eyeglass Cases</li></div>
                    <div class="col-4"><li>Eyeglass Cleaning Cloths</li></div>
                    <div class="col-4"><li>Eyeglass Frames</li></div>
                    <div class="col-4"><li>Eyeglass Lens Cleaners</li></div>
                    <div class="col-4"><li>Eyeglass Lenses</li></div>
                    <div class="col-4"><li>Eyeglass Repair Kits</li></div>
                    <div class="col-4"><li>Feminine Hygiene Deodorant Powders & Sprays</li></div>
                    <div class="col-4"><li>Feminine Hygiene Washes & Douches</li></div>
                    <div class="col-4"><li>Feminine Wipes</li></div>
                    <div class="col-4"><li>Fertility Charting</li></div>
                    <div class="col-4"><li>Fetal Dopplers</li></div>
                    <div class="col-4"><li>Fetish Wear</li></div>
                    <div class="col-4"><li>Fiber Supplements</li></div>
                    <div class="col-4"><li>Finger Cots</li></div>
                    <div class="col-4"><li>General Health Tests</li></div>
                    <div class="col-4"><li>Glucose Supplements</li></div>
                    <div class="col-4"><li>Gurneys</li></div>
                    <div class="col-4"><li>Gut Health Tests</li></div>
                    <div class="col-4"><li>Hair Loss Treatments</li></div>
                    <div class="col-4"><li>Hand-Free Breast Pump Bras</li></div>
                    <div class="col-4"><li>Hard Contact Lenses</li></div>
                    <div class="col-4"><li>Health Care Transfer Boards</li></div>
                    <div class="col-4"><li>Hearing Aid Batteries</li></div>
                    <div class="col-4"><li>Hearing Aid Cleaning Kits</li></div>
                    <div class="col-4"><li>Hearing Aids</li></div>
                    <div class="col-4"><li>Heart Rate Monitors</li></div>
                    <div class="col-4"><li>Herbal Supplements</li></div>
                    <div class="col-4"><li>Hernia Belts & Supports</li></div>
                    <div class="col-4"><li>HIV Tests</li></div>
                    <div class="col-4"><li>Homeopathic & Herbal Remedies</li></div>
                    <div class="col-4"><li>Hormone Supplements</li></div>
                    <div class="col-4"><li>Hormone Tests</li></div>
                    <div class="col-4"><li>Hospital Beds</li></div>
                    <div class="col-4"><li>Incontinence Cleansers & Deodorants</li></div>
                    <div class="col-4"><li>Incontinence Protective Underwear</li></div>
                    <div class="col-4"><li>Incontinence Underpads & Protectors</li></div>
                    <div class="col-4"><li>Infectious Disease Tests</li></div>
                    <div class="col-4"><li>Insulin Injectors</li></div>
                    <div class="col-4"><li>Itching & Rash Treatments</li></div>
                    <div class="col-4"><li>Jock Itch Treatments</li></div>
                    <div class="col-4"><li>Kegel Exercisers</li></div>
                    <div class="col-4"><li>Key Turning & Grip Aids</li></div>
                    <div class="col-4"><li>Knee Walker Scooters</li></div>
                    <div class="col-4"><li>Lead Testing Kits</li></div>
                    <div class="col-4"><li>Lice Combs</li></div>
                    <div class="col-4"><li>Lice Household Protection Sprays</li></div>
                    <div class="col-4"><li>Lice Shampoos</li></div>
                    <div class="col-4"><li>Lice Treatment Kits</li></div>
                    <div class="col-4"><li>Magnifiers & Low-Vision Aids</li></div>
                    <div class="col-4"><li>Male Fertility Tests</li></div>
                    <div class="col-4"><li>Manual Wheelchairs</li></div>
                    <div class="col-4"><li>Masturbators</li></div>
                    <div class="col-4"><li>Maternity Belly Prosthetics</li></div>
                    <div class="col-4"><li>Maternity Skin Care</li></div>
                    <div class="col-4"><li>Maternity Support Belts</li></div>
                    <div class="col-4"><li>Medical Alert Devices</li></div>
                    <div class="col-4"><li>Medical ID Bracelets</li></div>
                    <div class="col-4"><li>Medical Supply Plate Guards</li></div>
                    <div class="col-4"><li>Medical Supply Utensil Holders & Cuffs</li></div>
                    <div class="col-4"><li>Menopause Treatments</li></div>
                    <div class="col-4"><li>Menstrual Cups</li></div>
                    <div class="col-4"><li>Mineral Supplements</li></div>
                    <div class="col-4"><li>Mobility Aid Steps</li></div>
                    <div class="col-4"><li>Mobility Leg & Thigh Lifters</li></div>
                    <div class="col-4"><li>Mobility Lift Chairs</li></div>
                    <div class="col-4"><li>Mobility Lift Cushions</li></div>
                    <div class="col-4"><li>Mobility Ramps</li></div>
                    <div class="col-4"><li>Mobility Scooters</li></div>
                    <div class="col-4"><li>Mobility Walker Bags, Baskets & Carriers</li></div>
                    <div class="col-4"><li>Mobility Walker Flip Trays</li></div>
                    <div class="col-4"><li>Mobility Walker Glides & Balls</li></div>
                    <div class="col-4"><li>Mobility Walker Wheels</li></div>
                    <div class="col-4"><li>Mobility Walkers</li></div>
                    <div class="col-4"><li>Mold Testing Kits</li></div>
                    <div class="col-4"><li>Moleskin</li></div>
                    <div class="col-4"><li>Nasal Aspirators</li></div>
                    <div class="col-4"><li>Nasal Irrigators</li></div>
                    <div class="col-4"><li>Nausea Wristbands</li></div>
                    <div class="col-4"><li>Nebulizers</li></div>
                    <div class="col-4"><li>Nicotine Gums & Lozenges</li></div>
                    <div class="col-4"><li>Nicotine Patches</li></div>
                    <div class="col-4"><li>Nipple Shields</li></div>
                    <div class="col-4"><li>Nipple Soothing Creams</li></div>
                    <div class="col-4"><li>Non-Rebreather Bags & Masks</li></div>
                    <div class="col-4"><li>Nursing Covers</li></div>
                    <div class="col-4"><li>Nursing Pads</li></div>
                    <div class="col-4"><li>Nursing Pillows</li></div>
                    <div class="col-4"><li>Omega Fatty Acid Supplements</li></div>
                    <div class="col-4"><li>Optical Lens Cleaners</li></div>
                    <div class="col-4"><li>Optical Services</li></div>
                    <div class="col-4"><li>Orthodontic Elastics</li></div>
                    <div class="col-4"><li>Orthodontic Kits</li></div>
                    <div class="col-4"><li>Orthodontic Lip Guard Covers</li></div>
                    <div class="col-4"><li>Orthodontic Relief Wax</li></div>
                    <div class="col-4"><li>Orthodontic Retainer & Nightguard Cases</li></div>
                    <div class="col-4"><li>Orthodontic Retainers</li></div>
                    <div class="col-4"><li>Otoscopes</li></div>
                    <div class="col-4"><li>Over-the-Counter Medicines</li></div>
                    <div class="col-4"><li>Ovulation & Fertility Test Kits</li></div>
                    <div class="col-4"><li>Oxygen Concentrators</li></div>
                    <div class="col-4"><li>Panty Liners</li></div>
                    <div class="col-4"><li>Paternity Tests</li></div>
                    <div class="col-4"><li>Patient Lifts</li></div>
                    <div class="col-4"><li>Pediatric Nutrition Shakes</li></div>
                    <div class="col-4"><li>Penis Pumps & Enlargers</li></div>
                    <div class="col-4"><li>Penis Rings</li></div>
                    <div class="col-4"><li>Perineal Cleansers</li></div>
                    <div class="col-4"><li>Period Panties</li></div>
                    <div class="col-4"><li>Personal Sound Amplifiers</li></div>
                    <div class="col-4"><li>Physical Therapy Foot Rockers</li></div>
                    <div class="col-4"><li>Physical Therapy Hand Exercisers</li></div>
                    <div class="col-4"><li>Physical Therapy Putty</li></div>
                    <div class="col-4"><li>Physical Therapy Traction Equipment</li></div>
                    <div class="col-4"><li>Poison Ingestion Treatments</li></div>
                    <div class="col-4"><li>Poison Ivy, Oak & Sumac Cleansers</li></div>
                    <div class="col-4"><li>Postpartum Support Belts</li></div>
                    <div class="col-4"><li>Pregnancy & Nursing Pillow Covers</li></div>
                    <div class="col-4"><li>Pregnancy Pillows</li></div>
                    <div class="col-4"><li>Pregnancy Tests</li></div>
                    <div class="col-4"><li>Prescription Glasses</li></div>
                    <div class="col-4"><li>Prescription Medicines</li></div>
                    <div class="col-4"><li>Probiotic Supplements</li></div>
                    <div class="col-4"><li>Protein Supplements</li></div>
                    <div class="col-4"><li>Pulse Oximeters</li></div>
                    <div class="col-4"><li>Radon Testing Kits</li></div>
                    <div class="col-4"><li>Reaching Aids</li></div>
                    <div class="col-4"><li>Reading Glasses</li></div>
                    <div class="col-4"><li>Respiration Flow Meters</li></div>
                    <div class="col-4"><li>Sanitary Napkins</li></div>
                    <div class="col-4"><li>Sensual Bedding Sprays</li></div>
                    <div class="col-4"><li>Sex Dolls</li></div>
                    <div class="col-4"><li>Sex Furniture Ramps & Cushions</li></div>
                    <div class="col-4"><li>Sex Games</li></div>
                    <div class="col-4"><li>Sex Machines & Electronic Devices</li></div>
                    <div class="col-4"><li>Sex Swings</li></div>
                    <div class="col-4"><li>Sex Toy Catheters & Sounds</li></div>
                    <div class="col-4"><li>Sex Toy Cleaners</li></div>
                    <div class="col-4"><li>Sexual Arousal Creams & Gels</li></div>
                    <div class="col-4"><li>Sexual Desensitizing Creams & Gels</li></div>
                    <div class="col-4"><li>Sexual Health Tests</li></div>
                    <div class="col-4"><li>Sexual Lubricants</li></div>
                    <div class="col-4"><li>Sitz Baths</li></div>
                    <div class="col-4"><li>Sleeping Disorder Nasal Strips</li></div>
                    <div class="col-4"><li>Smokeless Inhalers</li></div>
                    <div class="col-4"><li>Snore Reducing Chin Straps</li></div>
                    <div class="col-4"><li>Snore Reducing Pillows</li></div>
                    <div class="col-4"><li>Sock Dressing Aids</li></div>
                    <div class="col-4"><li>Soft Contact Lenses</li></div>
                    <div class="col-4"><li>Spermicides</li></div>
                    <div class="col-4"><li>Spirometers</li></div>
                    <div class="col-4"><li>Stethoscope Accessories</li></div>
                    <div class="col-4"><li>Stethoscopes</li></div>
                    <div class="col-4"><li>Tampons</li></div>
                    <div class="col-4"><li>Toddler Formulas</li></div>
                    <div class="col-4"><li>Toilet Safety Frames</li></div>
                    <div class="col-4"><li>Transport Wheelchairs</li></div>
                    <div class="col-4"><li>Ultrasound Gels</li></div>
                    <div class="col-4"><li>Urinary Drainage Bags</li></div>
                    <div class="col-4"><li>Urinary Tract Infection Test Strips</li></div>
                    <div class="col-4"><li>Vaginal Moisturizers</li></div>
                    <div class="col-4"><li>Vaginal Pumps</li></div>
                    <div class="col-4"><li>Vibrators</li></div>
                    <div class="col-4"><li>Walking Cane & Crutch Tips</li></div>
                    <div class="col-4"><li>Walking Cane Flashlights</li></div>
                    <div class="col-4"><li>Walking Cane Holders</li></div>
                    <div class="col-4"><li>Walking Canes</li></div>
                    <div class="col-4"><li>Wart Removers</li></div>
                    <div class="col-4"><li>Wheelchair & Mobility Scooter Carriers</li></div>
                    <div class="col-4"><li>Wheelchair Bags & Baskets</li></div>
                    <div class="col-4"><li>Wheelchair Cushions</li></div>
                    <div class="col-4"><li>Wheelchair Lap Trays & Cup Holder</li></div>
                    <div class="col-4"><li>Yeast Infection Treatments</li></div>
                </div>
            </div>
        </div>
  </Layout>
)

export default NotFoundPage